import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { sashecQueuePush } from '../../utils/SashecHelpers'

class SashecAdvert extends Component {
  shouldComponentUpdate () {
    return false
  }

  componentDidMount () {
    if (typeof window !== 'undefined') {
      const {
        id,
        type,
        pos,
        async,
        size
      } = this.props

      const callback = event => {
        if (event.type === 'insert' && !event.is_empty) {
          const advertLabelContainerNode = document.getElementById(id).parentNode.firstChild
          if (advertLabelContainerNode) {
            advertLabelContainerNode.style.display = 'block'
          }
        }
      }

      const sashecPayload = [
        type,
        id,
        {
          pos,
          size,
          async,
          callback
        }
      ]
      sashecQueuePush(sashecPayload)
    }
  }

  render () {
    const {
      id
    } = this.props

    return (
      <div id={id}/>
    )
  }
}

SashecAdvert.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
  async: PropTypes.bool,
  pos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.array.isRequired,
  group: PropTypes.string
}

SashecAdvert.defaultProps = {
  type: 'position',
  async: true
}

export default SashecAdvert
